export default "__VITE_ASSET__BzIdgQMO__"